module.exports = __webpack_public_path__ + "media/backgrounds/thilak-mohan-NRX9Zy-k3nU-unsplash-2083c442.jpg";